var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("address-select-checkout", {
    ref: "invoice",
    attrs: {
      "address-type": "1",
      "show-error": _vm.showError,
      "optional-address-fields": _vm.optionalAddressFields,
      "required-address-fields": _vm.requiredAddressFields,
      "default-salutation": _vm.defaultSalutation,
      "padding-classes": _vm.paddingClasses,
      "padding-inline-styles": _vm.paddingInlineStyles,
    },
    on: { "address-changed": _vm.addressChanged },
    scopedSlots: _vm._u(
      [
        {
          key: "custom-address-fields",
          fn: function () {
            return [_vm._t("custom-address-fields")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }